<template>
  <div
    ref="containerOverlayRef"
    class="overlay__component overlay__component__container"
  >
    <div class="overlay__component__title-container">
      <div class="overlay__component__title">
        <slot name="title">
          Título
        </slot>
      </div>
      <div
        class="overlay__component__controls"
      >
        <div class="overlay__component__header-icon">
          <slot name="icon">
            <span class="pi pi-compass"></span>
          </slot>
        </div>
        <button
          class="overlay__component__closer p-overlaypanel-close p-link"
          @click="emit('closeOverlay')"
        >
          <span class="p-overlaypanel-close-icon pi pi-times">
          </span>
        </button>
      </div>
    </div>
    <div class="overlay__component__content">
      <slot></slot>
    </div>
    <div class="overlay__component__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>


<script setup>
import {ref, onMounted} from 'vue';
import Overlay from 'ol/Overlay';
// #region Props, Emits
// ...
const emit = defineEmits(['closeOverlay']);
// #endregion


// #region Params, Ref, Reactives, Computed
const containerOverlayRef = ref();
const overlayRef = ref(null);
// #endregion


// #region Functions
// ...
// #endregion


// #region Effects, Hooks
onMounted(() => {
  overlayRef.value = new Overlay({
    element: containerOverlayRef.value,
    autoPan: {
      animation: {
        duration: 250,
      },
      margin: 50,
    },
  });
});
// #endregion


// #region Provide, Expose
defineExpose({
  overlay: overlayRef,
});
// #endregion
</script>


<style lang="scss" scoped>
@use "src/styles/base";
@import "@/styles/custom-colors.scss";
.overlay__component {
  &__container {
    position: absolute;
    background-color: $brand__color--white;
    box-shadow: 0 1px 4px rgba($brand__color--black,0.2);
    border-radius: 0.25rem;
    border: 1px solid $brand__color--smoke;
    bottom: 12px;
    left: -50px;
    min-width: 300px;
    /* max-width: 50dvw; */
    max-width: 500px;
  }

  &__title-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.1rem;
    font-weight: bold;
    color: $solid-blue;
    margin-top: 0;
    text-align: left;
    background: $subtle-blue_80 !important;
    padding: 10px;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  &__title {
    flex: 1 1 90%;
    /* align-self: center; */
  }
  &__controls {
    flex: 1 1 10%;
    align-self: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 0.3rem;
  }
  &__header-icon {
    align-self: center;
    flex: 1 1 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    color: #005DA3;
    font-size: 1.5rem;
    flex: 1 1 100%;
    & :deep(.pi) {
      font-size: 1.5rem;
      font-weight: bold;
    }
  }

  &__content {
    padding: 0.50rem;
    max-height: 50dvh;
    overflow-y: auto;
  }
  &__footer {
    padding: 0.50rem;
  }

  &__closer {
    top: 0 !important;
    flex: 1 1 100%;
    align-self: center;
    border-radius: 50%;
    background: transparent;
    color: $solid-blue;
    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
    width: 2rem;
    height: 2rem;
    @include base.min-screen-width($brand__breakpoint--md) {
      width: 2rem;
      height: 2rem;
    }

    & :deep(.p-panel-close) {
      position: static !important;
    }
  }
  &__closer:hover {
    background: #106ebe;
    color: #ffffff;
  }
}
</style>
